import { useTranslation } from "react-i18next";
import { selectHistory, useRoundStore } from "../../state/roundStore.js";

function tier(crashAt: number): string {
  if (crashAt >= 50) return "extreme";
  if (crashAt >= 10) return "high";
  if (crashAt >= 2) return "mid";
  return "low";
}

/** Last rounds, colour-coded by the theme's history tiers. */
export function HistoryBar() {
  const { t } = useTranslation();
  const history = useRoundStore(selectHistory);

  if (history.length === 0) {
    return (
      <div className="cx-history-bar">
        <p>{t("history.empty")}</p>
      </div>
    );
  }

  return (
    <div className="cx-history-bar">
      <ul aria-label={t("history.title")}>
        {history.map((entry) => (
          <li key={entry.roundId} data-tier={tier(entry.crashAt)}>
            {entry.crashAt.toFixed(2)}x
          </li>
        ))}
      </ul>
    </div>
  );
}
